import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/storage_bill/:id', {
        template: require('./storage_bill.html'),
        controller: 'StorageBillController'
    });
})
.controller('StorageBillController', function($scope, $routeParams, $location, StorageBill, AccountStorageBill){
    $scope.newAdminURL = NEW_ADMIN_URL;
    let id = $routeParams.id;
    if (id == 'peek') {
        $scope.bill = AccountStorageBill.peek({account_id: $routeParams.account_id, starts_at: $routeParams.starts_at, ends_at: $routeParams.ends_at});
    } else {
        $scope.bill = StorageBill.get({id: id});
    }
});



// WEBPACK FOOTER //
// ./views/storage_bill/storage_bill_controller.js